<div class="version-row analytics-card-host" [class.is-refreshing]="isLoading()">
  <!-- Left card: Master Version Trend -->
  <div class="version-card">
    <div class="card-header">
      <div class="header-left">
        <h3 class="card-title">Master Version Trend</h3>
      </div>
      <div class="header-right">
        <div class="legend">
          <span class="legend-dot amber"></span>
          <span class="legend-label">Versions</span>
        </div>
        <div class="granularity-toggle">
          <button [class.active]="versionGranularity() === 'DAY'" (click)="onVersionGranularityChange('DAY')">Day</button>
          <button [class.active]="versionGranularity() === 'WEEK'" (click)="onVersionGranularityChange('WEEK')">Week</button>
          <button [class.active]="versionGranularity() === 'MONTH'" (click)="onVersionGranularityChange('MONTH')">Month</button>
        </div>
      </div>
    </div>
    <div class="chart-container">
      <ngx-charts-area-chart
        [results]="areaChartData"
        [scheme]="areaColorScheme"
        [xAxis]="true"
        [yAxis]="true"
        [showGridLines]="true"
        [autoScale]="true"
        [animations]="true"
        [xAxisTickFormatting]="formatXAxisTick">
      </ngx-charts-area-chart>
    </div>
  </div>

  <!-- Right card: Master Top Users - Updates -->
  <div class="version-card">
    <div class="card-header">
      <h3 class="card-title">Master Top Users - Updates</h3>
      <div class="granularity-toggle">
        <button [class.active]="updatesGranularity() === 'DAY'" (click)="onUpdatesGranularityChange('DAY')">Day</button>
        <button [class.active]="updatesGranularity() === 'WEEK'" (click)="onUpdatesGranularityChange('WEEK')">Week</button>
        <button [class.active]="updatesGranularity() === 'MONTH'" (click)="onUpdatesGranularityChange('MONTH')">Month</button>
      </div>
    </div>
    <div class="bar-chart" *ngIf="aggregatedUpdaters.length > 0">
      <div class="bar-row" *ngFor="let user of aggregatedUpdaters; let i = index">
        <div class="bar-user">
          <div class="user-avatar" [style.background]="getGradient(i)">
            {{ getInitials(user.firstName, user.lastName) }}
          </div>
          <span class="bar-user-name">{{ user.firstName }} {{ user.lastName }}</span>
        </div>
        <div class="bar-track-wrapper">
          <div class="bar-track">
            <div class="bar-fill" [style.width]="getBarWidth(user.total)" [style.background]="getBarColor(i)"></div>
          </div>
          <span class="bar-value">{{ user.total | number }}</span>
        </div>
      </div>
    </div>
    <div class="empty-state" *ngIf="!isLoading() && aggregatedUpdaters.length === 0">
      <span class="empty-text">No update data available</span>
    </div>
  </div>
</div>
